import { Radio, Switch } from 'antd';
import { formatNumber } from 'utils/numberFormat';
import { useState } from 'react';
import ItemTableContent from './ItemTableContent';
import NormalTableContent from './NormalTableContent';
import { useTranslate } from '@tolgee/react';

function TableContent({
  isVoice,
  isAdvantage,
  filter,
  categoryMap,
}: {
  isVoice?: boolean;
  isAdvantage?: boolean;
  filter: ReviewAnalysis.OverviewFilter;
  categoryMap: number[];
}) {
  const { t } = useTranslate();

  const formatter = (num: number) => formatNumber(num, '0,0');

  const [activeId, setActiveId] = useState(1);

  const [newProblemOnly, setNewProblemOnly] = useState(false);

  const header = (
    <header>
      <Radio.Group value={activeId} onChange={({ target: { value } }) => setActiveId(value)}>
        <Radio.Button value={1}>
          {t('knowledge.商品相关')}({formatter(categoryMap[1])})
        </Radio.Button>
        <Radio.Button value={2}>
          {t('物流配送')}({formatter(categoryMap[2])})
        </Radio.Button>
        <Radio.Button value={3}>
          {t('服务体验')}({formatter(categoryMap[3])})
        </Radio.Button>
        <Radio.Button value={4}>
          {t('活动营销')}({formatter(categoryMap[4])})
        </Radio.Button>
      </Radio.Group>
      {activeId !== 1 && (
        <span>
          {isAdvantage ? t('仅看新优点') : t('仅看新问题')}
          <Switch checked={newProblemOnly} onChange={setNewProblemOnly} />
        </span>
      )}
    </header>
  );

  const content =
    activeId === 1 ? (
      <ItemTableContent
        isVoice={isVoice}
        isAdvantage={isAdvantage}
        filter={filter}
        problemCategoryId={1}
      />
    ) : (
      <NormalTableContent
        isVoice={isVoice}
        isAdvantage={isAdvantage}
        filter={filter}
        newProblemOnly={newProblemOnly}
        problemCategoryId={activeId}
      />
    );

  return (
    <>
      {header}
      {content}
    </>
  );
}

export default TableContent;
